import moment from 'moment';
import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-renewal-accept-tc",
    prompt: (guidanceItem) => getPrompt(guidanceItem.planYearStartDate, guidanceItem.contractStartDate),
    details: (guidanceItem) => getDetails(guidanceItem.planYearStartDate, guidanceItem.contractStartDate),
    beforeLoad: async (component, guidanceItem) => {
        await component.refreshPermissions();
    },
    briefDescription: 'Accept T&C',
    openAction: {
        text: "Go To Your Order Form",
        url: (guidanceItem) => { return `/employer/${guidanceItem.employerId}/order/${guidanceItem.orderId}`; }
    },
    completeAction: { }
})

function getPrompt(){
    return "Welcome back! For each step of your renewal experience, you will find instructions in this panel to assist you. "
             + "If a step has additional information, click on the ? icon on the right. " 
}

function getDetails(planYearStartDate, contractStartDate) {
    var details = null;

    if(moment(planYearStartDate).isSame(moment(contractStartDate))) {
        details = 'For this step, review your order form below, <strong>agree to the Terms & Conditions</strong> and click <strong>\"I am done - Next\"</strong> on the right." '; 
    } else {
        details = 'For this step, review and <strong>confirm your order form</strong> below and click <strong>\"I am done - Next\"</strong> on the right." ';
    }

    return details + "If you wish to make any changes, click the \'Make Changes\' link."
}



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-renewal-accept-tc.js